import React, { useEffect } from 'react';
import Button from '../shared/Button';
import Modal from '../shared/Modal';
import * as styles from './styles/styles.module.scss';
import { StringConstantsMixin } from '../../application/javascripts/react_components/mixins/shared/string_constants_mixin';
import Card from './Card';

const MapSelectorModal = ({
  mapTypesCards,
  mapDetailsCards,
  additionalOptionsCards,
  taller,
  handleCardClick,
  handleHeatmapClick,
  handleResetClick,
  handleClose,
  handleActivityFilterChange,
  selectedFilterActivity,
  adminCustomizationSettings,
  handleAdminCustomizationSettingsChange,
  adminLayout,
  mobileBrowser,
  enabledOverlays
}) => {
  const handleKeyDown = e => {
    if (e.keyCode == 27) {
      // Esc
      handleClose();
    }
  };

  useEffect(() => {
    document.addEventListener('keydown', handleKeyDown);
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  });

  const renderCards = cards =>
    cards
      .filter(card => {
        if (card.disabledForFree) {
          return true;
        }
        if (card.title.endsWith(' heatmap')) {
          return false;
        }
        return !card.disabled;
      })
      .map(card => {
        return (
          <Card
            key={`card-${card.key}`}
            adminLayout={adminLayout}
            card={card}
            handleCardClick={handleCardClick}
            handleHeatmapClick={handleHeatmapClick}
            mobileBrowser={mobileBrowser}
            handleActivityFilterChange={handleActivityFilterChange}
            selectedFilterActivity={selectedFilterActivity}
            adminCustomizationSettings={adminCustomizationSettings}
            handleAdminCustomizationSettingsChange={handleAdminCustomizationSettingsChange}
            enabledOverlays={enabledOverlays}
          />
        );
      });

  const renderChildren = () => {
    if (adminLayout) {
      return (
        <>
          <div className={styles.cardsContainer}>{renderCards(mapDetailsCards)}</div>
          <h2 className={styles.sectionTitle}>{StringConstantsMixin.strings.MAP_TYPES}</h2>
          <div className={styles.cardsContainer}>{renderCards(mapTypesCards)}</div>
          <h2 className={styles.sectionTitle}>Additional options</h2>
          <div className={styles.cardsContainer}>{renderCards(additionalOptionsCards)}</div>
        </>
      );
    }

    return (
      <>
        <h2 className={styles.sectionTitle}>{StringConstantsMixin.strings.MAP_TYPES}</h2>
        <div className={styles.cardsContainer}>{renderCards(mapTypesCards)}</div>
        <h2 className={styles.sectionTitle}>{StringConstantsMixin.strings.MAP_DETAILS}</h2>
        <div className={styles.cardsContainer}>{renderCards(mapDetailsCards)}</div>
      </>
    );
  };

  const renderClose = () => {
    if (adminLayout) {
      return null;
    }
    return (
      <div className={styles.closeContainer}>
        <div className="close" onClick={handleClose} />
      </div>
    );
  };

  const adminStyles = () => {
    if (!adminLayout) {
      return null;
    }
    // Make popup wider for admins using Windows, otherwise scrollbar width causes line wrap
    const widenForScrollbars = window.navigator && window.navigator.userAgent.match(/Windows/);
    return `${styles.adminLayout} ${widenForScrollbars ? styles.widenForScrollbars : null}`;
  };

  return (
    <Modal handleBackgroundClick={handleClose} modalStyle={{ zIndex: 1003 }}>
      <div className={`${styles.mapSelectorContainer} ${taller ? styles.taller : null} ${adminStyles()}`}>
        {renderClose()}
        <div id="section-container" className={`reset-box-sizing ${styles.sectionContainer}`}>
          {renderChildren()}
        </div>
        <div className={styles.ctaFooter}>
          <Button classes={[styles.button, styles.reset].join(' ')} onClick={handleResetClick} variant="flat">
            {StringConstantsMixin.strings.RESET}
          </Button>
          <Button classes={[styles.button, styles.apply].join(' ')} onClick={handleClose} variant="primary">
            {StringConstantsMixin.strings.APPLY}
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default MapSelectorModal;
